<script setup lang="ts">
import type { SportSessionParticipant } from '@/composables/useSportSessions';

interface Props {
    participants: SportSessionParticipant[];
    isShared?: boolean;
    showText?: boolean;
    size?: 'sm' | 'md';
}

const props = withDefaults(defineProps<Props>(), {
    isShared: false,
    showText: true,
    size: 'sm'
});
</script>

<template>
    <div class="participants-container">
        <div v-for="(p, idx) in participants" 
             :key="p.id" 
             class="participant-badge"
             :class="size === 'md' ? 'badge-md' : 'badge-sm'"
             :title="p.name"
             :style="{ zIndex: participants.length - idx }">
            {{ p.name.charAt(0).toUpperCase() }}
        </div>
        <div v-if="showText" class="booked-text">
            <span v-if="!isShared">Inscrit</span>
            <span v-else>Réserver avec</span>
        </div>
    </div>
</template>

<style scoped>
.participants-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    margin-bottom: 2px;
}

.participant-badge {
    border-radius: 50%;
    background: #212529;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    position: relative;
    box-shadow: 0 1px 2px rgba(0,0,0,0.2);
}
.badge-sm {
    width: 20px;
    height: 20px;
    font-size: 0.6rem;
    border: 1px solid white;
    margin-left: -6px;
}
.badge-md {
    width: 26px;
    height: 26px;
    font-size: 0.75rem;
    border: 2px solid white;
    margin-left: -8px;
}
.participant-badge:first-child {
    margin-left: 0;
}

.booked-text {
    font-size: 0.65rem;
    font-weight: bold;
    margin-left: 4px;
    background: rgba(255, 255, 255, 0.7);
    padding: 1px 4px;
    border-radius: 4px;
}
</style>
